// Central place for reading/writing the JWT this app already expects
// (kundliApi.js and walletApi.js both read 'kc_access_token' from here).
const ACCESS_KEY = "kc_access_token";
const REFRESH_KEY = "kc_refresh_token";

export function isLoggedIn() {
  return !!localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY);
}

export function saveTokens(tokens) {
  if (tokens?.access) localStorage.setItem(ACCESS_KEY, tokens.access);
  if (tokens?.refresh) localStorage.setItem(REFRESH_KEY, tokens.refresh);
}

export function clearTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}
